import request from '@/utils/request'

//获得优惠券详情
export function getCouponDetail(params) {
  return request({
    url: '/product/coupon/qrcode/detail',
    method: 'get',
    params,
  })
}

//领取优惠券
export function takeCoupon(params) {
  return request({
    url: '/product/coupon/take',
    method: 'get',
    params,
  })
}
